import { jsx } from 'react/jsx-runtime';
import { Personal } from '@dls/assets/icons';
import { useCallback } from 'react';
import Anchor from '../../../Anchor/index.js';
import theme from '../../../../theme/index.js';
import '../../../../../StyleComponents/SCContainerStyledComponent.js';
import { SCDivStyledComponent } from '../../../../../StyleComponents/SCDivStyledComponents.js';
import '../../../../../StyleComponents/SCTextStyledComponent.js';
import { Margin } from '../../../../../StyleComponents/style.js';
const Profile = _ref => {
  let {
    url,
    theme: theme$1,
    onClick
  } = _ref;
  const onClickCallback = useCallback(e => {
    onClick && onClick(e);
    e.stopPropagation();
  }, [onClick]);
  return /* @__PURE__ */jsx(SCDivStyledComponent, {
    css: Margin("x", 3),
    children: /* @__PURE__ */jsx(Anchor, {
      href: url,
      onClick: onClickCallback,
      ariaLabel: "User Profile",
      children: /* @__PURE__ */jsx(Personal, {
        size: 24,
        color: theme$1 === "dark" ? theme.colours.white : theme.colours.black
      })
    })
  });
};
export { Profile as default };